import React from 'react';
import PropTypes from 'prop-types';
import RfrLink, { NavLink as RfrNavLink } from 'redux-first-router-link';
import {
  MenuItemLabelType,
  MenuItemActionType,
  MenuItemUrlType,
  MenuItemIsExternalType,
} from '../proptypes/menu.proptypes';

class Link extends React.Component {
  // constructor() {
  //   super();
  //   this._link = RfrLink;
  // }

  get LinkComponent() {
    return RfrLink;
  }

  useFallback({ isExternal }) {
    return isExternal;
  }

  grabLocalProps({ label, action, url, children, isExternal, restricted, ...props }) {
    return {
      label, action, url, children, isExternal, restricted, props,
    };
  }

  rfrProps({ down, shouldDispatch, redirect, ...remain }) {
    return {
      down, shouldDispatch, redirect, remain,
    };
  }

  renderFallback() {
    const { props, ...local } = this.grabLocalProps(this.props);
    const { remain } = this.rfrProps(props);
    const { label, url, children } = local;
    return (<a href={url} {...remain}>{children || label}</a>);
  }

  renderComponent() {
    const { props, ...local } = this.grabLocalProps(this.props);
    const { label, action, url, children } = local;

    return (
      <this.LinkComponent to={action || url} {...props}>
        {children || label}
      </this.LinkComponent>
    );
  }

  render() {
    if (this.useFallback(this.props)) {
      return this.renderFallback();
    }
    return this.renderComponent();
  }
}

Link.propTypes = {
  label: MenuItemLabelType,
  action: MenuItemActionType,
  url: MenuItemUrlType,
  isExternal: MenuItemIsExternalType,
  children: PropTypes.node,
};

Link.defaultProps = {
  label: '',
  action: null,
  url: '',
  isExternal: false,
  children: null,
};

class NavLink extends Link {
  // constructor() {
  //   super();
  //   this._link = RfrNavLink;
  // }

  get LinkComponent() {
    return RfrNavLink;
  }

  rfrProps({
    down, shouldDispatch, redirect, activeClassName,
    activeStyle, exact, strict, isActive, ...remain
  }) {
    return {
      down,
      shouldDispatch,
      redirect,
      activeClassName,
      activeStyle,
      exact,
      strict,
      isActive,
      remain,
    };
  }
}

export default Link;
export { NavLink };



// WEBPACK FOOTER //
// ./src/lib/components/link.js